export class AdminUpdateDataModel {
    public offset = 0;
    public query = '';
    public limit = 100;
    public dateSentAtStart = '';
    public dateSentAtEnd = '';
    public statuses = [] as string[];
    public apiProblemsOnly = false;
}
